<template>
  <div>
    <b-modal
      ref="modal"
      title="Pagar contas"
      header-class="border-bottom-0"
      footer-class="border-top-0"
      size="xl"
      no-close-on-backdrop
    >
      <!-- heading  -->
      <div>
        <div class="row grid-table-heading d-none d-md-flex">
          <div class="col-md-4">Conta</div>
          <div class="col-md-8 d-flex" style="padding: 0px">
            <div class="col-2 text-right">Saldo devedor</div>
            <div class="col-2 text-right">Pagar</div>
            <div class="col-2 text-right">Desconto</div>
            <div class="col-2 text-right">Acrescimo</div>
            <div class="col-2 text-right">Juros</div>
            <div class="col-2 text-right">Valor a Pagar</div>
          </div>
        </div>
        <hr />

        <!-- bills  -->
        <template v-for="(billForm, index) in billsForm">
          <div class="row align-items-center" :key="index">
            <!-- fist column  -->
            <div class="col-md-4 mb-3 mb-md-0">
              {{ billForm.name }}
              <br />
              <small class="text-muted"
                >Documento: {{ billForm.document }}</small
              >
            </div>

            <!-- secont column  -->
            <div class="col-md-8">
              <div class="row">
                <!-- saldo devedor -->
                <div class="col-6 d-block d-md-none">
                  <small>Saldo devedor:</small>
                </div>
                <div class="col-6 col-md-2 mb-md-0 mb-2 p-md-2 text-right">
                  <number-input
                    :formGroupClass="'mb-0'"
                    :value="billForm.ramainder_value"
                    :disabled="true"
                  ></number-input>
                </div>

                <!-- saldo devedor -->
                <div class="col-6 d-block d-md-none">
                  <small>Pagamento:</small>
                </div>
                <div class="col-6 col-md-2 mb-md-0 mb-2 p-md-2">
                  <number-input
                    :formGroupClass="'mb-0'"
                    v-model="billForm.payed_value"
                  ></number-input>
                </div>

                <!-- desconto -->
                <div class="col-6 d-block d-md-none">
                  <small>Desconto:</small>
                </div>
                <div class="col-6 col-md-2 mb-md-0 mb-2 p-md-2 text-right">
                  <number-input
                    :formGroupClass="'mb-0'"
                    v-model="billForm.discount"
                  ></number-input>
                </div>

                <!-- acrescimo -->
                <div class="col-6 d-block d-md-none">
                  <small>Acrescimo:</small>
                </div>
                <div class="col-6 col-md-2 mb-md-0 mb-2 p-md-2">
                  <number-input
                    :formGroupClass="'mb-0'"
                    v-model="billForm.addition"
                  ></number-input>
                </div>

                <!-- juros -->
                <div class="col-6 d-block d-md-none">
                  <small>Juros:</small>
                </div>
                <div class="col-6 col-md-2 mb-md-0 mb-2 p-md-2">
                  <number-input
                    :formGroupClass="'mb-0'"
                    v-model="billForm.interest"
                  ></number-input>
                </div>

                <!-- valor a pagar -->
                <div class="col-6 d-block d-md-none">
                  <small>Valor a pagar:</small>
                </div>
                <div class="col-6 col-md-2 mb-md-0 mb-2 p-md-2 pr-md-3">
                  <number-input
                    :formGroupClass="'mb-0'"
                    :value="
                      billForm.payed_value -
                      billForm.discount +
                      billForm.addition +
                      billForm.interest
                    "
                    :disabled="true"
                  />
                </div>
              </div>

              <!-- second row -->
              <div>
                <template
                  v-if="billForm.payed_value < billForm.ramainder_value"
                >
                  <div class="text-right" :key="'alert' + index">
                    <small class="text-info"
                      >Ficará restando um saldo devedor de
                      {{
                        (billForm.ramainder_value - billForm.payed_value)
                          | decimal
                      }}
                      para está conta.</small
                    >
                  </div>
                </template>
                <template
                  v-if="billForm.payed_value > billForm.ramainder_value"
                >
                  <div class="text-right" :key="'alert2' + index">
                    <small class="text-danger"
                      >Impossivel pagar um valor maior que o saldo
                      devedor.</small
                    >
                  </div>
                </template>
              </div>
              <!-- second row -->
            </div>
          </div>
          <hr :key="'hr' + index" />
        </template>
        <br />
        <div class="row">
          <div class="col-md-4 offset-md-8">
            <div class="row mb-2">
              <div class="col-8">Total do Pagamento:</div>
              <div class="col-4 text-right">
                {{ sum_payed_value | decimal }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-8">Total desconto:</div>
              <div class="col-4 text-right">{{ sum_discount | decimal }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-8">Total Acrescimo:</div>
              <div class="col-4 text-right">{{ sum_addition | decimal }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-8">Total Juros:</div>
              <div class="col-4 text-right">{{ sum_interest | decimal }}</div>
            </div>
            <hr class="mt-1 mb-1" />
            <div class="row mb-2">
              <div class="col-8">
                <b>Total a pagar:</b>
              </div>
              <div class="col-4 text-right">
                <b class="text-danger">{{ sum_net_payed_value | decimal }}</b>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-12">
                <account-select-input @input="setAccount($event)" />
                <!-- <select-input
                  v-model="account_id"
                  :alias="'Selecione uma conta'"
                  :options="accounts"
                /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <error-handler :error="error" />

      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="$refs.modal.hide()"
        >
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button
          role="button"
          class="btn btn-success"
          style="margin-left: 5px"
          @click="store()"
        >
          <i class="fas fa-check"></i> Pagar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import AccountSelectInput from "../../account/inputs/AccountSelectInput.vue";
export default {
  components: { AccountSelectInput },
  data: function () {
    return {
      account_id: null,
      //accounts : {},
      bills: {},
      billsForm: [],
      error: null,
    };
  },

  async created() {
    await this.$store.dispatch("account/getAccounts", { status: 1 });
  },

  computed: {
    accounts() {
      let accounts = {};
      for (let index in this.$store.state.account.accounts) {
        accounts[
          this.$store.state.account.accounts[index].id
        ] = this.$store.state.account.accounts[index].description;
      }
      return accounts;
    },

    sum_payed_value() {
      return this.billsForm.reduce((sum, row) => sum + row.payed_value, 0);
    },

    sum_discount() {
      return this.billsForm.reduce((sum, row) => sum + row.discount, 0);
    },

    sum_addition() {
      return this.billsForm.reduce((sum, row) => sum + row.addition, 0);
    },

    sum_interest() {
      return this.billsForm.reduce((sum, row) => sum + row.interest, 0);
    },

    sum_net_payed_value() {
      return (
        this.sum_payed_value -
        this.sum_discount +
        this.sum_addition +
        this.sum_interest
      );
    },
  },

  methods: {
    open(bills) {
      this.accounts;

      this.bills = bills;

      this.setBillsFormData(bills);

      this.$refs.modal.show();
    },

    setAccounts(accounts) {
      for (let index in accounts) {
        this.accounts[accounts[index].id] = accounts[index].description;
      }
    },

    setBillsFormData(bills) {
      this.billsForm = [];

      for (let index in bills) {
        let billForm = this.getBillFormData(bills[index]);

        this.$set(this.billsForm, index, billForm);
      }
    },

    getBillFormData(bill) {
      let billForm = {};

      billForm.id = bill.id;

      if (bill.person_id) {
        billForm.name = bill.vendor_description;
        if (bill.description) {
          billForm.name += " | " + bill.description;
        }
      } else {
        billForm.name = bill.description;
      }

      billForm.document = bill.document;
      billForm.ramainder_value =
        Math.round((bill.value - bill.received_value) * 100) / 100;
      billForm.payed_value =
        Math.round((bill.value - bill.received_value) * 100) / 100;
      billForm.discount = 0;
      billForm.addition = 0;
      billForm.interest = 0;

      return billForm;
    },

    getStoreParams() {
      return {
        account_id: this.account_id,
        bills: this.billsForm,
      };
    },

    store() {
      this.$store.commit("showLoading");
      this.$store
        .dispatch("billpayable/postPayBillPayable", this.getStoreParams())
        .then((response) => {
          this.$refs.modal.hide();
          this.$emit("stored");
          this.$store.commit("showAlert", {
            message: "Lançamento Atualizado!",
            type: "success",
          });
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.error = error;
          this.$store.commit("hideLoading");
        });
    },
    setAccount(account) {
      this.account_id = account.id;
    }
  }
};
</script>
